import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../pages/css/PhoneNumberList.css';
import banner from '../images/Hrias-b2b-banner.png';
import verifiedPhone from '../images/Hrias-fb-1.png';
import phoneConnect from '../images/Hrias-fb-2.png';
import b2bcrm from '../images/Hrias-linked-3.png.jpg';
import phoneMultiple from '../images/Hrias-fb-3.png';
import phoneMultiple2 from '../images/Hrias-fb-4.png';
import cTOne from '../images/kpmg.png';
import cTTwo from '../images/deloite.png';
import cTThree from '../images/berkshire.png';
import cTFive from '../images/pwc.jpg';
import cTSix from '../images/microsoft.png';
import cTFour from '../images/Google.png';
import dashImg from '../images/Hrias-linked-dash.jpg';

function FacebookProspecting() {
    return (
        <div className="phone-list-page">

            {/* ===== Hero Section ===== */}
            <section
                className="hero-section text-center text-white d-flex align-items-center justify-content-center"
                style={{
                    backgroundImage:
                        `url(${banner})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    width: "100%",
                    height: "40vh",
                }}
            >
                <div className="container" style={{ color: "#ffffff" }}>
                    <h1 className="fw-bold" style={{ color: "#275a8eff" }}>
                        Add Facebook to your outreach mix &  <span className="highlight" style={{ color: "#7102c1ff" }}>get 2.5x more replies</span>
                    </h1>
                    <p className="lead mt-3" style={{ color: "#890059ff" }}>
                        Find Facebook leads, push them to multichannel campaigns, and let automation handle the rest. Visits, invites, text messages - all from 1 tool.
                    </p>
                    <button
                        className="btn btn-primary mt-4"
                        style={{
                            backgroundColor: "#134373ff",
                            border: "none",
                            color: "#ffffffff",
                            fontWeight: "600",
                            borderRadius: "30px",
                            padding: "12px 30px",
                            transition: "all 0.3s ease",
                        }}
                        onMouseOver={(e) => (e.target.style.backgroundColor = "#5197dcff")}
                        onMouseOut={(e) => (e.target.style.backgroundColor = "#134373ff")}
                    >
                        Contact Sales
                    </button>
                </div>

            </section>

            <section>
                <div className="container py-5">
                    <img
                        src={dashImg}
                        alt="Padded Container"
                        className="img-fluid rounded shadow-lg"
                    />
                </div>
            </section>

            <section className="container my-5 partner-section">
                {/* Heading */}
                <h5 className="text-center partner-heading">
                    Trusted by <span style={{ color: '#fd7e14' }}>6000+</span> Industry Leaders
                </h5>

                {/* Logo Row */}
                <div className="d-flex justify-content-center align-items-center flex-wrap gap-4 mt-4">
                    <img src={cTOne} alt="KPMG" className="partner-logo" style={{ width: '120px', height: 'auto' }} />
                    <img src={cTTwo} alt="Deloitte" className="partner-logo" style={{ width: '130px', height: 'auto' }} />
                    <img src={cTThree} alt="Berkshire" className="partner-logo" />
                    <img src={cTFour} alt="Google" className="partner-logo" />
                    <img src={cTFive} alt="PwC" className="partner-logo" />
                    <img src={cTSix} alt="Microsoft" className="partner-logo" />
                </div>
            </section>


            <section className="accuracy-section py-5 bg-light">
                <div className="container text-center">
                    <h2 className="section-heading">Find Facebook Leads That Truly Matter with HRIAS</h2>
                    <p className="text-muted mb-4">
                        Discover and add qualified Facebook leads to your outreach campaigns directly from the HRIAS database or using the HRIAS .
                        Enrich profiles with verified business data, and let AI automatically clean, score, and segment your leads for maximum engagement and conversion success.
                    </p>
                    <img
                        src={verifiedPhone}
                        alt="Verification Process"
                        className="img-fluid rounded shadow"
                    />
                </div>
            </section>

            {/* ===== Section 2: Overview ===== */}
            <section className="overview-section py-5">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <h2 className="fw-bold mb-3">Grab Attention with Automated Facebook Profile Visits via HRIAS</h2>
                            <p>
                                Automatically visit your leads’ profiles to show genuine interest, increase visibility, and warm them up for future connection or outreach — all seamlessly managed through HRIAS multichannel automation.
                            </p>
                        </div>
                        <div className="col-md-6 text-center">
                            <img src={phoneConnect} alt="Phone list" className="img-fluid rounded shadow" />
                        </div>
                    </div>
                </div>
            </section>



            {/* ===== Section 5: Two Image Boxes ===== */}
            <section className="two-box-section py-5 bg-light">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-md-6">
                            <div className="image-box p-3 rounded shadow-sm h-100">
                                <h4 className="fw-bold mb-2">Connect and Build Lasting Trust with HRIAS</h4>
                                <p>Send personalized Facebook connection requests automatically, engage with leads through their posts, and nurture relationships that strengthen your credibility and position you as a trusted industry voice — all within HRIAS multichannel automation</p>
                                <img src={phoneMultiple} alt="Instant Access" className="img-fluid rounded mt-3" />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="image-box p-3 rounded shadow-sm h-100">
                                <h4 className="fw-bold mb-2">Text Not Enough? Send Voice with HRIAS!</h4>
                                <p>Stand out from the crowd by sending personalized voice notes to your leads.
                                    Record once — or let HRIAS AI clone your voice to create unique, natural messages at scale, making every outreach more human and memorable.</p>
                                <img src={phoneMultiple2}alt="Custom Data" className="img-fluid rounded mt-3" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="accuracy-section py-5 bg-light">
                <div className="container text-center">
                    <h2 className="section-heading">Manage Every Facebook Conversation Seamlessly with Your Team on HRIAS</h2>
                    <p className="text-muted mb-4">
                        Handle all your multichannel conversations — Facebook, Email, and WhatsApp — from one unified shared inbox.
                        Collaborate effortlessly by replying as teammates, managing multiple accounts without switching tabs, and staying organized with tags, filters, and lead assignments — all within HRIAS.
                    </p>
                    <img
                        src={b2bcrm}
                        alt="Verification Process"
                        className="img-fluid rounded shadow"
                    />
                </div>
            </section>

            {/* ===== Section 6: Credibility / Stats ===== */}
            <section className="stats-section py-5 text-center">
                <div className="container">
                    <h2 className="fw-bold mb-4">Trusted by Sales Teams Globally</h2>
                    <div className="row justify-content-center">
                        <div className="col-md-3 mb-3">
                            <h3 className="text-primary fw-bold">98%</h3>
                            <p>Accuracy Rate</p>
                        </div>
                        <div className="col-md-3 mb-3">
                            <h3 className="text-primary fw-bold">500K+</h3>
                            <p>Verified Numbers</p>
                        </div>
                        <div className="col-md-3 mb-3">
                            <h3 className="text-primary fw-bold">150+</h3>
                            <p>Countries Covered</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* ===== Section 7: Call to Action ===== */}
            <section className="cta-section text-center py-5">
                <div className="container">
                    <h2 className="fw-bold mb-3 text-white">Start Accessing Verified Facebook Accounts Today</h2>
                    <p className="mb-4">Boost your sales calls and connect faster with decision-makers using 100% verified data.</p>
                    <button className="btn btn-primary px-4 py-2">Contact Sales</button>
                </div>
            </section>

            <section className="container my-5 client-review-section">
                <div className="row align-items-center">
                    {/* Left side - client image */}
                    <div className="col-12 col-md-3 text-center">
                        <img
                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZiPwNzz_t6AAyoIDTb2uFl1N8BEWhUzz-CQ&s" // replace with your client's photo
                            alt="Client"
                            className="client-img"
                        />
                    </div>

                    {/* Right side - review text */}
                    <div className="col-12 col-md-9">
                        <p className="client-review">
                            “HRIAS Facebook Prospecting tools helped our sales team connect with verified professionals and real decision-makers faster than ever.
                            The precision of the data is incredible — no more fake profiles or irrelevant leads.
                            It’s completely optimized our Facebook outreach and increased our connection-to-conversion rate significantly!”
                        </p>
                        <h3 className="client-name">Michael Reynolds</h3>
                        <p className="client-position">Head of Growth, NovaReach Technologies</p>

                    </div>
                </div>
            </section>

        </div>
    );
}

export default FacebookProspecting;
